import React from 'react';

// eslint-disable-next-line max-len
const WEFLUENS = '/themes/theme/wefluens/wefluens.png';
const WEFLUENS_DARK_LOGO = '/themes/theme/wefluens/wefluens.png';

const WefluensTheme = {
  headerLogo: {
    src: WEFLUENS,
    alt: 'Wefluens Logo',
    size: 60,
  },
  darkLogo: {
    src: WEFLUENS_DARK_LOGO,
    alt: 'Wefluens Logo',
    size: 60,
  },
  linkStyle: {
    color: '#DA1F59',
    fontWeight: 800,
    fontSize: '120%',
  },
  headerStyle: {
    backgroundColor: '#fff',
    borderBottom: '4px solid #DA1F59',
    height: 100,
  },
  title: 'Wefluens',
  isLightOnDark: false,
  organisationId: '542d8875-c943-4b40-a972-150c39ac511b',
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <img
        height="60"
        src={WEFLUENS} alt="Wefluens Logo"
      />
      <br /><br />
    </div>
  ),
  shareSite: 'https://share.wefluens.com',
};

export default WefluensTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/wefluens.js
 **/